import { render, staticRenderFns } from "./ServiceRecords.vue?vue&type=template&id=058bb35f&scoped=true"
import script from "./ServiceRecords.vue?vue&type=script&lang=js"
export * from "./ServiceRecords.vue?vue&type=script&lang=js"
import style0 from "./ServiceRecords.vue?vue&type=style&index=0&id=058bb35f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058bb35f",
  null
  
)

export default component.exports